import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { IScheduleAssembly, IScheduleDaypartOverride } from 'src/interfaces';
import { requestCCApi } from 'src/utils';
import { queryKeys } from 'src/utils/queryKeys';

export interface scheduleDaypartOverrideTransaction {
  resource: string;
  method: string;
  id?: string | number | null;
  data: Partial<IScheduleDaypartOverride> | Partial<IScheduleAssembly>;
}

export const useCreateOrUpdateScheduleDaypartOverrides = () => {
  return useMutation({
    mutationFn: (payload: scheduleDaypartOverrideTransaction[]) =>
      updateOrCreateScheduleDaypartOverrides(payload),
    onSuccess: () => {
      queryClient.invalidateQueries(
        queryKeys.scheduleDaypartAssemblies.invalidateAll(),
      );
      queryClient.invalidateQueries(queryKeys.scheduleDayparts.invalidateAll());
      queryClient.invalidateQueries(
        queryKeys.scheduleAssemblies.invalidateAll(),
      );
      queryClient.invalidateQueries(
        queryKeys.scheduleDaypartOverrides.invalidateAll(),
      );

      queryClient.invalidateQueries(
        queryKeys.defaultAssemblies.invalidateAll(),
      );
      queryClient.invalidateQueries(
        queryKeys.locationActiveDays.invalidateAll(),
      );
      queryClient.invalidateQueries(queryKeys.assemblies.invalidateAll());
      queryClient.invalidateQueries(queryKeys.assemblyListing.invalidateAll());
    },
  });
};

export async function updateOrCreateScheduleDaypartOverrides(
  payload: scheduleDaypartOverrideTransaction[],
) {
  const response = await requestCCApi({
    url: `/transaction`,
    method: 'POST',
    data: {
      data: payload,
    },
  });

  return response;
}
